import { memo, useEffect } from 'react';
import './Modal.css';

const ReelsModal = ({ children, isOpen }) => {

    // useEffect(() => {
    //     const chatWidget = document.querySelector("jdiv");

    //     if (isOpen) {
    //         // Hide widget and disable scroll
    //         if (chatWidget) chatWidget.style.display = "none";
    //         document.body.style.overflow = "hidden";
    //     } else {
    //         // Show widget and restore scroll
    //         if (chatWidget) chatWidget.style.display = "block";
    //         document.body.style.overflow = "auto";
    //     }

    //     // Cleanup when component unmounts
    //     return () => {
    //         if (chatWidget) chatWidget.style.display = "block";
    //         document.body.style.overflow = "auto";
    //     };
    // }, [isOpen]);

    if (!isOpen) return null;

    return <div className="modal-overlay-stories">
        <div className="modal-content-stories">
            {children}
        </div>
    </div>
};

export default memo(ReelsModal);